import { render, staticRenderFns } from "./activityAction.vue?vue&type=template&id=47401e0b&scoped=true"
import script from "./activityAction.vue?vue&type=script&lang=js"
export * from "./activityAction.vue?vue&type=script&lang=js"
import style0 from "./activityAction.vue?vue&type=style&index=0&id=47401e0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47401e0b",
  null
  
)

export default component.exports